import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "antique"
const AntiqueIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 10h.5c0-3.157-1.168-4-5.2-4C4 6 2 9 2 10v5h1a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h2c0-.47-.27-1.441-1-2.403V11h-1.826c-1.027-.59-2.39-1-4.174-1Zm-6 0H3.5c0-1.373 2.934-2.328 6.5-2.479V10Zm1.5 0V7.5c3.5.016 3.5.236 3.5 2.5h-3.5ZM6 13.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm12 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
          />
        </svg>
      }
    </span>
  )
}
export default AntiqueIcon
